import React, { useCallback } from 'react';
import { ProformaTemplateLibraryInDrawer } from '@atlassian/jira-proforma-template-library/src/ui/index.tsx';
import type { TemplateForm } from '@atlassian/proforma-common-core/form-system-models';
import { useRouter } from '@atlassian/react-resource-router';
import { useCreateForm } from '../../services/use-create-form';

type Props = {
	projectId: number;
};

export function FormSettingsTemplateLibrary({ projectId }: Props) {
	const { callCreateForm } = useCreateForm(projectId);
	const [{ location }, { push }] = useRouter();

	const handleTemplateSelected = useCallback(
		async (templateId: string, template: TemplateForm) => {
			const result = await callCreateForm({ templateId, template });

			if (result) {
				push(`${location.pathname}/form/${result.form.id}/edit`);
			}
		},
		[push, callCreateForm, location.pathname],
	);

	return <ProformaTemplateLibraryInDrawer onTemplateSelected={handleTemplateSelected} />;
}
